import { render, staticRenderFns } from "./AiSuggestNoteDrawerComp.vue?vue&type=template&id=2b93588f&scoped=true"
import script from "./AiSuggestNoteDrawerComp.vue?vue&type=script&lang=js"
export * from "./AiSuggestNoteDrawerComp.vue?vue&type=script&lang=js"
import style0 from "./AiSuggestNoteDrawerComp.vue?vue&type=style&index=0&id=2b93588f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93588f",
  null
  
)

export default component.exports